module.exports = __webpack_public_path__ + "static/img/flow_bot.0fd8cadb.svg";